const brandsData = [
    {
        id:"1",
        image: require("../../assets/image/1.jpg"),
        category:"medical"
    },
    {
        id:"2",
        image: require("../../assets/image/2.jpg"),
        category:"sports"
    },
    {
        id:"3",
        image: require("../../assets/image/3.jpg"),
        category:"modern"
    },
    {
        id:"4",
        image: require("../../assets/image/1.jpg"),
        category:"medical"
    },
    {
        id:"5",
        image: require("../../assets/image/2.jpg"),
        category:"sports"
    },
    {
        id:"6",
        image: require("../../assets/image/3.jpg"),
        category:"modern"
    },
    {
        id:"7",
        image: require("../../assets/image/1.jpg"),
        category:"medical"
    },
    {
        id:"8",
        image: require("../../assets/image/2.jpg"),
        category:"sports"
    },
    {
        id:"9",
        image: require("../../assets/image/3.jpg"),
        category:"modern"
    },
]

export default brandsData;